module.exports = __webpack_public_path__ + "img/lls.17ece5a0.jpg";